<comp-card-header>
  <span headline>{{ 'model.finding.plural' | translate }}</span>
  <ng-container action-items>
    <div class="prime-action-bar">
      <button comp-button type="button" (click)="addFinding()">
        <i comp-icon>add</i>
        <span>{{ 'requirementIntake.details.findings.add' | translate }}</span>
      </button>
    </div>
  </ng-container>
</comp-card-header>
<comp-findings-list [dataSource]="dataSource" [findingsType]="findingsType()"></comp-findings-list>
